module.exports = __webpack_public_path__ + "img/logo_cat.02b3b0f5.png";